import { render, staticRenderFns } from "./GlobalNotifications.vue?vue&type=template&id=658a776a&scoped=true&"
import script from "./GlobalNotifications.vue?vue&type=script&lang=js&"
export * from "./GlobalNotifications.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNotifications.vue?vue&type=style&index=0&id=658a776a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a776a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VDialog,VIcon,VOverlay,VProgressCircular})
